export enum MatchStatisticsEventEnum {
  Possession = "POSSESSION",
  Passes = "PASSES",
  Interception = "PASS_INTERCEPTED",
}
